import { List } from 'immutable';

import { localeMiddleware } from './locale/loader';
import { loggingMiddleware } from './middleware/logging';
import { timestampMiddleware } from './middleware/timestamp';

export const middleware = List([localeMiddleware, timestampMiddleware, loggingMiddleware]);
